export default "__VITE_ASSET__BV0sB8WK__"